export const SubmissionReviewStatuses = {
    UNREVIEWED: 1,
    PARTIALLY_REVIEWED: 2,
    REVIEWED: 3,
}

export const getReviewStatusName = status => {
    switch (status) {
        case SubmissionReviewStatuses.UNREVIEWED:
            return 'Unreviewed'
        case SubmissionReviewStatuses.PARTIALLY_REVIEWED:
            return 'Partially Reviewed'
        case SubmissionReviewStatuses.REVIEWED:
            return 'Reviewed'
        default:
            return 'Unknown Review Status'
    }
}
